'use client'

import React from 'react';
import { StyledDiv } from './affiliatesDosDonts.styles';

export const AffiliatesDosDonts = () => {

    return (
        <StyledDiv>
            <h2>Do’s & Don’ts</h2>
            <div className="rules-wrapper">
                <div className="can">
                    <h6>You Can</h6>
                    <ul>
                        <li>Promote common ninja on social media.</li>
                        <li>Write about Common Ninja on blogs and articles.</li>
                        <li>Create educational Common Ninja video tutorials.</li>
                        <li>Place common ninja logos & banners on websites.</li>
                        <li>Send your affiliate link to email subscribers.</li>
                    </ul>
                </div>
                <div className="cant">
                    <h6>You {`Can't`}</h6>
                    <ul>
                        <li>
                            You {`can't`} use your affiliate link on coupon or discount websites
                            or offer unofficial discounts or coupon codes.
                        </li>
                        <li>You can’t falsely advertise Common Ninja in any manner.</li>
                        <li>
                            You do not represent Common Ninja, and cannot pretend to be
                            acting on behalf of us.
                        </li>
                        <li>You can’t modify our logos or banners.</li>
                        <li>
                            You {`can't`} use your affiliate link for your own purchases
                            (self-referrals).
                        </li>
                        <li>
                            You can’t advertise Common Ninja through pay-per-click ads,
                            especially on branded terms or domain names (including, but no
                            limited to, search engines, social media ads, and video
                            banners).
                        </li>
                        <li>
                            You can’t abuse or attempt to mislead us, or users, pretending
                            to be us.
                        </li>
                    </ul>
                </div>
            </div>
            <div className="small">
                <p className="dark">
                    Any violation of the above term will result in your account being
                    permanently banned.
                </p>
                <p>
                    We reserve the right to change the Terms of Service for our affiliate
                    program at any time.
                </p>
            </div>
        </StyledDiv>
    );
};

